export default {
  // 可能是通用的
  New_Chat: '新聊天',
  Tools: '工具',
  AI_Presentation: 'AI PPT',
  AI_ChatPDF: 'ChatPDF',
  My_Vip: '我的會員資格',
  AI_Image: 'AI 圖片',
  AI_Translation: 'AI 翻譯',
  Text_Optimezation: '文稿優化',
  Assets: '資產',
  Chat_History: '歷史',
  Pricing: '會員套裝'
  // 独有
  // aside: {
  //   video_image: 'AI 視訊/AI 繪畫'
  // }
}
